import { createRoot } from "react-dom/client"

// normalize CSS across browsers
import "./src/v3/styles/normalize.css"
// global styles
import "./src/global.scss"
// send to piano analytics
// import { pianoAnalytics } from "piano-analytics-js"

export function replaceHydrateFunction() {
  return (element, container) => {
    const root = createRoot(container)
    root.render(element)
  }
}

/*const sendToPianoAnalytics = () => {
  const clientId = uuid()
  const siteId = parseInt(config.piano_site_id)

  if (isNaN(siteId)) {
    return
  }

  pianoAnalytics.setConfigurations({
    site: siteId,
    collectDomain: "https://nssvsmp.pa-cd.com",
  })
  pianoAnalytics.setVisitorId(clientId)
  pianoAnalytics.sendEvent("page.display", {
    page_chapter1: "Test dev kcom",
    page: "index",
  })
}

sendToPianoAnalytics()*/
